import * as R from 'ramda';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import React, { useState, useEffect, useCallback } from 'react';
// helpers/constants
import * as G from '../../helpers';
// icons
import * as I from '../../svgs';
// ui
import { AbsoluteBox } from '../../ui';
// feature select-mui
import { StyledFormControl } from './ui';
//////////////////////////////////////////////////

const SelectMui = (props) => {
  const {
    sx,
    options,
    isNative,
    initialValue,
    useDarkColor,
    wrapperStyles,
    multiple = true,
    isClearable = true,
    maxMenuHeight = 190,
    handleChangeCallback,
    muiFieldSize = 'small',
    label = G.getWindowLocale('titles:choose', 'Choose'),
  } = props;

  const emptyValue = G.ifElse(multiple, [], '');

  const [value, setValue] = useState(R.or(initialValue, emptyValue));

  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = useCallback(() => {
    setIsFocused(true);
  }, []);

  const handleBlur = useCallback(() => {
    setIsFocused(false);
  }, []);

  const handleChange = (value) => {
    setValue(value);

    G.callFunctionWithArgs(handleChangeCallback, value);
  };

  useEffect(() => {
    if (G.notEquals(value, initialValue)) setValue(R.or(initialValue, emptyValue));
  }, [initialValue]);

  const menuProps = {
    PaperProps: {
      style: {
        maxHeight: maxMenuHeight,
      },
    },
  };

  const ItemComponent = isNative ? 'option' : MenuItem;

  return (
    <StyledFormControl
      {...G.spreadUiStyles(wrapperStyles)}
      sx={sx}
      size={muiFieldSize}
      useDarkColor={useDarkColor}
      focusedOrHasValue={R.or(isFocused, G.isNotNilAndNotEmpty(value))}
    >
      <InputLabel id='select-mui' size={muiFieldSize} sx={{ top: '-1px' }}>
        {label}
      </InputLabel>
      <Select
        value={value}
        id='select-mui'
        native={isNative}
        multiple={multiple}
        size={muiFieldSize}
        labelId='select-mui'
        onBlur={handleBlur}
        onFocus={handleFocus}
        MenuProps={menuProps}
        input={<OutlinedInput label={label} />}
        onChange={(e) => handleChange(G.getEventTargetValue(e))}
        endAdornment={
          R.and(G.isTrue(isClearable), G.isNotNilAndNotEmpty(value)) &&
          <AbsoluteBox
            right='0px'
            cursor='pointer'
            padding='10px 5px'
            onClick={() => handleChange(emptyValue)}
          >
            {I.closeIcon(G.getThemeByCond(useDarkColor, 'colors.dark.mainDark', 'colors.dark.blue'))}
          </AbsoluteBox>
        }
      >
        {
          options.map(({ name, label, value }, index) => {
            const option = R.or(label, name);

            return <ItemComponent value={value} key={`${index}${option}`}>{option}</ItemComponent>;
          })
        }
      </Select>
    </StyledFormControl>
  );
};

export {
  SelectMui,
};
